const auth = {
  auth: {
    login: {
      title: "Administration",
      subtitle: "Connectez-vous pour gérer votre portfolio",
      emailLabel: "Adresse email",
      passwordLabel: "Mot de passe",
      submit: "Se connecter",
      errorFallback: "Erreur de connexion",
    },
    forgotPassword: {
      button: "Mot de passe oublié ?",
      title: "Réinitialiser le mot de passe",
      subtitle: "Saisissez votre adresse email pour recevoir un lien de réinitialisation.",
      emailLabel: "Adresse email",
      send: "Envoyer le lien",
      backToLogin: "Retour à la connexion",
      success: "Si un compte existe pour cet email, un lien de réinitialisation vous a été envoyé.",
      error: "Erreur lors de l'envoi du lien",
    },
  },
};

export default auth;
